
<br>
<div class="container-fluid">

    <div class="overlay">
        <app-user-form (searchOutput)="search($event)"></app-user-form>
    </div>
</div>
<br>
<div class="container" id="user">
    <div class="row">
        <div class="col-sm-3">
            <div class="userimg">
                <div class="card-img-top">
                    <img src="{{user.avatar_url}}" alt="">
                </div>
            </div>
        </div>
        <div class="col-sm-3"></div>
        <div class="col-sm-3" id="info">
            <div class="card-body ">
                <h5>Github-Username -:
                    {{user.login}}
                </h5><br>
                <hr>
                <p><i class="fa fa-file-o" style="font-size:28px"></i> &nbsp;&nbsp; Repositories:&nbsp;&nbsp;
                    {{user.public_repos}}
                </p>
                <p><i class="fa fa-user-circle" aria-hidden="true" style="font-size:28px"></i> &nbsp;&nbsp; Following :
                    &nbsp;&nbsp;
                    {{user.following}}
                </p>
                <p><i class="fa fa-user-plus" aria-hidden="true" style="font-size:28px"></i> &nbsp;&nbsp; Followers :
                    &nbsp;&nbsp;
                    {{user.followers}}
                </p>
                <p><i class="fa fa-clock-o" aria-hidden="true" style="font-size:28px"></i> &nbsp;&nbsp; Joined on :
                {{user.created_at|date}}
                </p>
            </div>
        </div>
    </div>
</div>
<div class="text-center repos">
    <h3>User Repositories</h3>
    <br>
    <div class="container" repos>
        <div class="row">
            <div class="card" *ngFor = 'let repo of repo' id="each">
                <div class="card-body">
                    <h5 class="card-tittle"><span id="component">Repo name : &nbsp;</span>
                        {{repo.name}}
                    </h5>
                    <div class="card-text">
                        <hr>
                        <div class="dec">
                            <span id="component"> Description : &nbsp;</span>
                        {{repo.description}}
                        </div>
                        <hr>
                        <div class="card-subtitle mb-2">
                            <span id="component"> Language used : &nbsp;</span>
                            {{repo.language}}
                        </div>
                        <hr>
                        <div class="card-subtitle mb-2">
                            <span id="component"> Created&nbsp; <span id="created"></span> &nbsp; on:</span><br>
                            {{repo.created_at}}
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="clearfix"><a class="btn btn-sm btn-warning pull-center" href="{{repo.html_url}}">View this project on github</a></p>
                </div>
            </div>
        </div>
    </div>
</div>